import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { scrollToId } from "@/lib/lenis";

const links = [
  { label: "The Method", target: "#method" },
  { label: "Commandments", target: "#commandments" },
  { label: "Voltage Matrix", target: "#voltage" },
  { label: "About", target: "#about" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      data-testid="navbar"
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 transition-[background-color,border-color,backdrop-filter] duration-500 ${
        scrolled
          ? "bg-ink/85 backdrop-blur-xl border-b border-gold/15"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-10 h-16 sm:h-20 flex items-center justify-between">
        <button
          data-testid="nav-wordmark"
          onClick={() => scrollToId("#hero")}
          className="font-serif text-lg sm:text-xl tracking-[0.28em] text-gold uppercase"
        >
          Joe&nbsp;Fenix
        </button>
        <nav className="hidden md:flex items-center gap-8" data-testid="nav-links">
          {links.map((l) => (
            <button
              key={l.label}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              onClick={() => scrollToId(l.target)}
              className="text-[11px] uppercase tracking-[0.22em] text-neutral-400 hover:text-gold transition-colors duration-300"
            >
              {l.label}
            </button>
          ))}
        </nav>
        <button
          data-testid="nav-apply-button"
          onClick={() => scrollToId("#intake-application")}
          className="border border-copper/70 text-copper-hover hover:bg-copper hover:text-white text-[11px] uppercase tracking-[0.22em] px-4 sm:px-6 py-2.5 transition-colors duration-300"
        >
          Apply
        </button>
      </div>
    </motion.header>
  );
}
